import styled from 'styled-components';
import { motion } from 'framer-motion'

export const Wrapper = styled.section`
    position: relative;
    width: 100%;
    height: 100%;
`

export const ImageWrapper = styled(motion.div)`
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;


    & > .background {
        width: 100%;
        height: 100%;
    }
`